import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Apple, Smartphone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="hidden md:block bg-gray-50 border-t border-gray-100 mt-16">
      <div className="container-k py-12 grid grid-cols-12 gap-8">
        <div className="col-span-4">
          <div className="text-2xl font-extrabold mb-3" style={{ color: '#ff5b00' }}>xlook</div>
          <p className="text-sm text-gray-600 mb-4">The go-to travel platform for experiences and services around the world. Book tours, attractions, tickets, activities and more.</p>
          <div className="flex items-center gap-3">
            <a href="#" className="p-2 rounded-full bg-white border hover:border-gray-300"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="p-2 rounded-full bg-white border hover:border-gray-300"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="p-2 rounded-full bg-white border hover:border-gray-300"><Twitter className="w-4 h-4" /></a>
            <a href="#" className="p-2 rounded-full bg-white border hover:border-gray-300"><Youtube className="w-4 h-4" /></a>
          </div>
        </div>
        <div className="col-span-2">
          <div className="font-semibold mb-3 text-sm">Xlook</div>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><Link to="/">About us</Link></li>
            <li><a href="#">Careers</a></li>
            <li><a href="#">Press</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Affiliates</a></li>
          </ul>
        </div>
        <div className="col-span-2">
          <div className="font-semibold mb-3 text-sm">Support</div>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><a href="#">Help Center</a></li>
            <li><a href="#">Contact</a></li>
            <li><a href="#">Terms & Conditions</a></li>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Cookie Policy</a></li>
          </ul>
        </div>
        <div className="col-span-2">
          <div className="font-semibold mb-3 text-sm">Partners</div>
          <ul className="space-y-2 text-sm text-gray-600">
            <li><a href="#">Become a supplier</a></li>
            <li><a href="#">Xlook for Business</a></li>
            <li><a href="#">Affiliate program</a></li>
          </ul>
        </div>
        <div className="col-span-2">
          <div className="font-semibold mb-3 text-sm">Get the app</div>
          <a href="#" className="flex items-center gap-2 px-3 py-2 mb-2 rounded-lg bg-black text-white text-xs">
            <Apple className="w-4 h-4" /> Download on App Store
          </a>
          <a href="#" className="flex items-center gap-2 px-3 py-2 rounded-lg bg-black text-white text-xs">
            <Smartphone className="w-4 h-4" /> Get it on Google Play
          </a>
        </div>
      </div>
      <div className="border-t border-gray-200">
        <div className="container-k py-4 text-xs text-gray-500 flex justify-between">
          <span>© 2025 Xlook Clone. Built for demo purposes only.</span>
          <span>All prices in USD unless specified.</span>
        </div>
      </div>
    </footer>
  );
}
